import script from "./pop-up-chamado.vue?vue&type=script&setup=true&lang=js"
export * from "./pop-up-chamado.vue?vue&type=script&setup=true&lang=js"

import "./pop-up-chamado.vue?vue&type=style&index=0&id=07260f62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07260f62"]])

export default __exports__